import { createModel } from '@rematch/core';
import { get } from '@ug/utils';

export default createModel()({
  state: {
    userInfo: null,
  },
  reducers: {
    setState: (state: any, payload: any) => ({ ...state, ...payload }),
  },
  effects: {
    async getUserInfo(data = {}) {
      const rst = await get('/mapi/login/get-dayu-login-user', data);
      if (rst?.login) {
        this.setState({
          userInfo: rst,
        });
        return rst;
      }
      return null;
    },
  },
});
